module.exports = __webpack_public_path__ + "img/Silver Plus.6eb34738.png";